import axios from 'axios';
import React, {useState, useEffect} from 'react';
import Select from "react-select";
import { v4 as uuidv4 } from "uuid";
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import "../../../index.css";
import { url } from '../../../Config';


export default function Fs(props) {
    const [apidata, setapidata] = useState([]);
    const [group, setgroup] = useState([]);
    const [selectedGroup, setSelectedGroup] = useState();
    const [mainsector, setmainsector] = useState([]);
    const [selectedMainSector, setselectedMainSector] = useState([]);
    const [sector, setsector] = useState([]);
    const [selectedSector, setselectedSector] = useState([]);
    const [opinion, setopinion] = useState([]);
    const [selectedOpinion, setselectedOpinion] = useState([]);
    const [period, setperiod] = useState([]);
    const [selectedPeriod, setselectedPeriod] = useState([]);
    const [period_data, setperiod_data] = useState({});
    const [singleperiod_data, setsingleperiod_data] = useState([]);
    const [periodtitle, setperiodtitle] = useState([]);
    const [opinionarr, setopinionarr] = useState([]);
    const [comparisondata, setcomparisondata] = useState([]);
    const [periodlabel, setperiodlabel] = useState([]);
    const [COLUMN_WIDTH, setCOLUMN_WIDTH] = useState(300);
    const  [loading, setloading] = useState("loading");
    

    useEffect(()=>{

        const func = async ()=>{

            const res = await axios.get(`https://209.97.168.200/pacrawizpackv3/public/get-fs-data`);
            const resp = res.data;
            setapidata(resp);
            console.log(resp ,'resp')

            const seen = new Set();
            const uniquegroupArray = [];
            


            resp.forEach(item => {
                const groupvar = item.group;
                if (groupvar && groupvar !== null && groupvar.trim() !== '') {
                    const groupLower = groupvar.toLowerCase();
                    if (!seen.has(groupLower)) {
                    seen.add(groupLower);
                    uniquegroupArray.push({
                        value: uuidv4(),
                        label: groupvar
                    });
                    }
                }
                });


            setgroup(uniquegroupArray);
            setloading("loaded");

            
        }
        func();


    },[])


    const handleSelect = (data)=>{
        setSelectedGroup(data);

    setmainsector([]);
    setselectedMainSector([]);
    setsector([]);
    setselectedSector([]);
    setopinion([]);
    setselectedOpinion([]);
    setperiod([]);
    setselectedPeriod([]);
    setperiodlabel([]);
        const arr = [];
        for(let i in apidata){
            if(apidata[i].group == data.label){
                arr.push(apidata[i]);
            }
        }

         const seen = new Set();
         const uniquemainsectorArray = [];


        arr.forEach(item => {
                const mainsectorvar = item.main_sector;
                if (mainsectorvar && mainsectorvar !== null && mainsectorvar.trim() !== '') {
                    const mainsectorLower = mainsectorvar.toLowerCase();
                    if (!seen.has(mainsectorLower)) {
                    seen.add(mainsectorLower);
                    uniquemainsectorArray.push({
                        value: mainsectorvar,
                        label: mainsectorvar
                    });
                    }
                }
            });

        setmainsector(uniquemainsectorArray);
    }


    const handleSelect2 = (data)=>{
        setselectedMainSector(data);

        setsector([]);
        setselectedSector([]);
        setopinion([]);
        setselectedOpinion([]);
        setperiod([]);
        setselectedPeriod([]);
        setperiodlabel([]);


        const arr = [];
        for(let i in apidata){
            if(apidata[i].main_sector == data.label){
                arr.push(apidata[i]);
            }
        }

         const seen = new Set();
         const uniquesectorArray = [];


        arr.forEach(item => {
                const sectorvar = item.sector;
                if (sectorvar && sectorvar !== null && sectorvar.trim() !== '') {
                    const sectorLower = sectorvar.toLowerCase();
                    if (!seen.has(sectorLower)) {
                    seen.add(sectorLower);
                    uniquesectorArray.push({
                        value: sectorvar,
                        label: sectorvar
                    });
                    }
                }
                });

        setsector(uniquesectorArray);
    }

    const handleSelect3 = (data)=>{
        setselectedSector(data);

        setopinion([]);
        setselectedOpinion([]);
        setperiod([]);
        setselectedPeriod([]);
        setperiodlabel([]);


        const arr = [];
        for(let i in apidata){
            if(apidata[i].sector == data.label){
                arr.push(apidata[i]);
            }
        }

         const seen = new Set();
         const uniqueopinionArray = [];
         uniqueopinionArray.push({ value: '*', label: 'Select All' });


        arr.forEach(item => {
                const opinionvar = item.opinion_name;
                if (opinionvar && opinionvar !== null && opinionvar.trim() !== '') {
                    const opinionLower = opinionvar.toLowerCase();
                    if (!seen.has(opinionLower)) {
                    seen.add(opinionLower);
                    uniqueopinionArray.push({
                        value: opinionvar,
                        label: opinionvar
                    });
                    }
                }
        });

        uniqueopinionArray.sort((a, b) => {
            if (a.label === 'Select All') return -1; // Always keep 'Select All' at the top
            if (b.label === 'Select All') return 1;
            return a.label.localeCompare(b.label);   // Sort remaining alphabetically
        });
        setopinion(uniqueopinionArray);

    }

    // Utility to extract Date object from label like "Sep-24  3M"
    function extractDate(str) {
    const match = str.match(/([A-Za-z]{3})-(\d{2})/); // e.g., ["Sep-24", "Sep", "24"]
    if (!match) return new Date(0); // fallback
    const [_, monthStr, yearStr] = match;
    const month = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"].indexOf(monthStr);
    const year = parseInt(yearStr, 10) + 2000;
    return new Date(year, month);
    }

    const handleSelect4 = (data)=>{
         if (!data) {
            setselectedOpinion([]);
            setperiod([]);
            setselectedPeriod([]);
            setperiodlabel([]);
            return;
        }

        let newdata = [];

         const isSelectAllSelected = data.some(opt => opt.value === '*');
         const isCurrentlyAllSelected = selectedOpinion.length === opinion.length - 1;

        if (isSelectAllSelected && !isCurrentlyAllSelected) {
            // Select all real options (excluding 'Select All')
            setselectedOpinion(opinion.filter(opt => opt.value !== '*'));
            newdata = opinion.filter(opt => opt.value !== '*');
        } else if (isSelectAllSelected && isCurrentlyAllSelected) {
            // Deselect all
            setselectedOpinion([]);
            
        } else {
            // Normal selection
            newdata = data.filter(opt => opt.value !== '*');
            setselectedOpinion(data.filter(opt => opt.value !== '*'));
        }

        setperiod([]);
        setselectedPeriod([]);
        setperiodlabel([]);

        // setselectedOpinion(data);

        const arr = [];
        const keys = [];
        const perioddataarr = [];
        const opinionarr2 = [];

        for(let i in newdata){
            keys.push(newdata[i].label)
        }

        for(let i in newdata){
            for(let j in apidata){
                if(apidata[j].opinion_name == newdata[i].label){
                    const key = Object.keys(apidata[j].data);
                    arr.push(key);
                    perioddataarr.push(apidata[j].data)
                    opinionarr2.push(apidata[j].opinion_name);
                    // for(let i in key){
                    //     arr.push({value:uuidv4(), label: key[i]});
                    // }
                    // setperiod(arr);
                    // setperiod_data(apidata[i].data);
                   
                }
            }
        }
        setopinionarr(opinionarr2);
        setperiod_data(perioddataarr);
        console.log(perioddataarr, 'perioddataarr');

        if(!arr.length){
            return;
        }

        // console.log(arr[0], 'arr');
        // let commonSet = new Set(arr[0]);

        // // Intersect with the rest of the subarrays
        // for (let i = 1; i < arr.length; i++) {
        //     commonSet = new Set(arr[i].filter(item => commonSet.has(item)));
        // }
        // // Convert Set to Array (preserves order of last intersection)
        // // return Array.from(commonSet);
        // const commonarr = Array.from(commonSet);

        // console.log(commonarr, 'common')

        const rawResult = [...new Set(arr.flat())];

        // let arrfinal = [];
        // for(let i in commonarr){
        //     arrfinal.push({value:uuidv4(), label: commonarr[i]});
        // }
        // for(let i in result){
        //     arrfinal.push({value:uuidv4(), label: result[i]});
        // }

        // Step 1: Sort descending
        const sorted = [...rawResult].sort((a, b) => extractDate(b) - extractDate(a));

        // Step 2: Mark the first one (latest) with highlight
        const latest = sorted[0];

        const arrfinal = sorted.map(label => ({
        value: uuidv4(),
        label,
        highlight: label === latest
        }));

        console.log(arrfinal ,'arrfinal');

            const selectAllOption = { value: '*', label: 'Select All' };
             setperiod([selectAllOption, ...arrfinal]);



        // setperiod(arrfinal);

    }

    const customStyles = {
    option: (provided, state) => ({
      ...provided,
      color: state.data.highlight ? 'red' : provided.color
    }),
    singleValue: (provided, state) => ({
      ...provided,
      color: state.data.highlight ? 'red' : provided.color
    }),
    menu: (provided) => ({
    ...provided,
    zIndex: 9999, // Very high to appear on top
  }),
  };

  const customSelectStyles = {
  menu: (provided) => ({
    ...provided,
    zIndex: 9999, // Very high to appear on top
  }),
};

    const handleSelect5 = (data)=>{
        
        // setselectedPeriod(data);


        let newdata = [];

         const isSelectAllSelected = data.some(opt => opt.value === '*');
         const isCurrentlyAllSelected = selectedPeriod.length === period.length - 1;

        if (isSelectAllSelected && !isCurrentlyAllSelected) {
            // Select all real options (excluding 'Select All')
            setselectedPeriod(period.filter(opt => opt.value !== '*'));
            newdata = period.filter(opt => opt.value !== '*');
        } else if (isSelectAllSelected && isCurrentlyAllSelected) {
            // Deselect all
            setselectedPeriod([]);
            
        } else {
            // Normal selection
            newdata = data.filter(opt => opt.value !== '*');
            setselectedPeriod(data.filter(opt => opt.value !== '*'));
        }


        let keys = [];

        for(let i in newdata){
                keys.push(newdata[i].label)
        }
        setperiodtitle(keys);

        let newperiod_data = period_data;

        const allKeys = new Set();
        for (const item of newperiod_data) {
            Object.keys(item).forEach((key) => allKeys.add(key));
        }

        // Step 2: Build a template for each key using the fullest version
        const templates = {};

        for (const key of allKeys) {
            for (const item of newperiod_data) {
            if (item[key]) {
                templates[key] = item[key]; // just store one as the base template
                break;
            }
            }
        }

        // Step 3: Helper to clone the structure with default 0s
        const createBlankFromTemplate = (template) => {
            const blank = [];
            let currentSection = null;

            for (const row of template) {
            if (row.length === 1) {
                currentSection = row[0];
                blank.push([currentSection]);
            } else {
                const [id, val] = row;
                const isEmptyString = val === '';
                blank.push([id, isEmptyString ? '' : 0]);
            }
            }

            return blank;
        };

        console.log(keys, 'keys');

        // Step 4: Fill in missing arrays with blanks
        const normalized = newperiod_data.map((item) => {
            const newItem = { ...item };
            for (const key of allKeys) {
            if (!newItem[key]) {
                newItem[key] = createBlankFromTemplate(templates[key]);
            }
            }
            return newItem;
        });

        const arraybasedonOP = [];

        for(let i in opinionarr){
            const result2 = [];

            const sectionMap = new Map(); // Keeps ordered sections and row IDs per section
            const lookups = []; // Lookup tables for each key/array
            // let result = [];

            // for (let key of keys) {

            //     const currentArray = period_data[i][key];
        
            //     for (let i = 0; i < currentArray.length; i++) {
            //         const row = currentArray[i];
            //         if (!result[i]) {
            //         // First time adding this row — make a copy
            //         result[i] = [...row];
            //         } else if (row.length === 1) {
            //         // Header row like ['A1'], ['B1'], etc. — do nothing
            //         continue;
            //         } else {
            //         // Data row — append only values, not the label
            //         result[i].push(...row.slice(1));
            //         }

            //     }

            // }

            // arraybasedonOP.push({name: opinionarr[i], data: result});

            setperiodlabel(keys);

            console.log(normalized, 'normalized')

            for (const key of keys) {
                let currentArray = normalized[i][key];
                 // 🧼 Clean unnecessary header row like ["", "Audited"]
                if (currentArray.length > 0 && currentArray[0][0] === '') {
                    currentArray = currentArray.slice(1);
                }
                const map = {};
                let currentSection = null;

                for (const row of currentArray) {
                    if (row.length === 1) {
                    currentSection = row[0];
                    if (!sectionMap.has(currentSection)) {
                        sectionMap.set(currentSection, []);
                    }
                    } else {
                    const [id, val] = row;
                    if (!sectionMap.get(currentSection).includes(id)) {
                        sectionMap.get(currentSection).push(id);
                    }
                    map[id] = map[id] || {};
                    map[id][currentSection] = val;
                    }
                }

                lookups.push(map);
                }

                // Step 2: Build result2 from sectionMap and lookups
                for (const [section, ids] of sectionMap.entries()) {
                result2.push([section]); // Push section header like ['A']

                for (const id of ids) {
                    const row = [id];
                    for (const map of lookups) {
                    if (map[id] && section in map[id]) {
                        row.push(map[id][section]); // can be '', number, etc.
                    } else {
                        row.push(0); // Only insert 0 if missing completely
                    }
                    }
                    result2.push(row);
                }
                }

                // console.log(result2, 'result');
                arraybasedonOP.push({name: opinionarr[i], data: result2});


    }

            let opinioncompilation = arraybasedonOP;

            let reference = opinioncompilation.reduce((max, curr) =>
                curr.data.length > max.data.length ? curr : max
            );

            const template = reference.data;

            // Step 2: Normalize each opinion to match the reference structure
            for (const opinion of opinioncompilation) {
                if (opinion === reference) continue; // Skip the reference itself

                const rowMap = new Map(); // Map section:id => row
                let currentSection = null;

                for (const row of opinion.data) {
                if (row.length === 1) {
                    currentSection = row[0];
                } else {
                    rowMap.set(`${currentSection}:${row[0]}`, row);
                }
                }

                const normalized = [];
                let currentTemplateSection = null;

                for (const row of template) {
                if (row.length === 1) {
                    currentTemplateSection = row[0];
                    normalized.push([currentTemplateSection]);
                } else {
                    const key = `${currentTemplateSection}:${row[0]}`;
                    const original = rowMap.get(key);

                    if (original) {
                    normalized.push(original);
                    } else {
                    // Create empty row with correct column count
                    const columnCount = row.length;
                    normalized.push([row[0], ...Array(columnCount - 1).fill(0)]);
                    }
                }
                }

                opinion.data = normalized;
            }

            //   return opinioncompilation;


            setcomparisondata(opinioncompilation);
    // setsingleperiod_data(result);
    }

    // Extract structure from the most complete opinion
        const template =
        comparisondata.length > 0
            ? comparisondata.reduce((a, b) =>
                a.data.length > b.data.length ? a : b
            ).data
            : [];

        // Build section structure like: [{ name: 'A', rows: ['ia', 'ib'] }, ...]
        // const sections = [];
        // let currentSection = null;

        // for (const row of template) {
        //     if (row.length === 1) {
        //     currentSection = { name: row[0], rows: [] };
        //     sections.push(currentSection);
        //     } else if (currentSection) {
        //     currentSection.rows.push(row[0]);
        //     }
        // }



        // const normalizeValue = (value) => {
        //     if (typeof value !== 'string' && typeof value !== 'number') return 0;

        //     let str = String(value).trim();

        //     // Handle NA, N/A, empty string
        //     if (str === '' || str.toUpperCase() === 'NA' || str.toUpperCase() === 'N/A') {
        //         return 0;
        //     }

        //     // Remove commas
        //     str = str.replace(/,/g, '');

        //     // Handle percentage like "10%"
        //     if (str.endsWith('%')) {
        //         str = str.slice(0, -1);
        //     }

        //     // Handle negative in brackets like "(15)"
        //     if (/^\(\d+(\.\d+)?\)$/.test(str)) {
        //         str = '-' + str.slice(1, -1);
        //     }

        //     const num = parseFloat(str);
        //     return isNaN(num) ? 0 : num;
        //     };


function normalizeValue(val) {
  if (!val || val === 'NA' || val === 'N/A') return 0;
  if (typeof val === 'string') {
    if (val.includes('%')) return parseFloat(val.replace('%', ''));
    if (val.startsWith('(') && val.endsWith(')'))
      return -parseFloat(val.replace(/[()]/g, '').replace(/,/g, ''));
    return parseFloat(val.replace(/,/g, '')) || 0;
  }
  return typeof val === 'number' ? val : 0;
}

function formatNumber(num) {
  return Number(num).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

  const sections = [];

  // Build section list from all data
  const sectionMap = new Map();
  for (const op of comparisondata) {
    let currentSection = '';
    for (const row of op.data) {
      if (row.length === 1) {
        currentSection = row[0];
        if (!sectionMap.has(currentSection)) sectionMap.set(currentSection, new Set());
      } else {
        sectionMap.get(currentSection).add(row[0]);
      }
    }
  }

  for (const [sectionName, ids] of sectionMap.entries()) {
    sections.push({
      name: sectionName,
      rows: Array.from(ids),
    });
  }

  // Calculate totals and averages
  const columnSums = Array(comparisondata.length * periodlabel.length).fill(0);
  const columnCounts = Array(comparisondata.length * periodlabel.length).fill(0);

  const getCellValue = (op, section, rowId) => {
    let currentSection = '';
    for (const row of op.data) {
      if (row.length === 1) {
        currentSection = row[0];
      } else if (currentSection === section && row[0] === rowId) {
        return row.slice(1);
      }
    }
    return Array(periodlabel.length).fill('');
  };


      const handleExportFullTable = () => {
  const wsData = [];

  // Header row 1: OP1 | OP2
  const opHeaders = [''];
  comparisondata.forEach(op =>
    opHeaders.push(...Array(periodlabel.length).fill(op.name))
  );
  opHeaders.push('Average');
  wsData.push(opHeaders);

  // Header row 2: arr1 | arr2 | ...
  const labelRow = [''];
  comparisondata.forEach(() =>
    periodlabel.forEach(label => labelRow.push(label))
  );
  labelRow.push('Average');
  wsData.push(labelRow);

  // Prepare body
  const template =
    comparisondata.length > 0
      ? comparisondata.reduce((a, b) =>
          a.data.length > b.data.length ? a : b
        ).data
      : [];

  const sections = [];
  let currentSection = null;
  for (const row of template) {
    if (row.length === 1) {
      currentSection = { name: row[0], rows: [] };
      sections.push(currentSection);
    } else if (currentSection) {
      currentSection.rows.push(row[0]);
    }
  }

  sections.forEach(section => {
    // Section title row
    wsData.push([section.name]);

    section.rows.forEach(rowId => {
      const rowData = [rowId];

      const allValues = [];

      comparisondata.forEach(op => {
        let current = '';
        let matched = null;

        for (const row of op.data) {
          if (row.length === 1) current = row[0];
          else if (current === section.name && row[0] === rowId) {
            matched = row;
            break;
          }
        }

        const values = matched ? matched.slice(1) : Array(periodlabel.length).fill(0);
        rowData.push(...values);
        allValues.push(...values);
      });

      // Aggregate
      const numericValues = allValues
        .map(normalizeValue)
        .filter(v => typeof v === 'number' && !isNaN(v));
      const avg = numericValues.length === 0 ? 0 : numericValues.reduce((a, b) => a + b, 0) / numericValues.length;
      rowData.push(avg.toFixed(2));

      wsData.push(rowData);
    });
  });

  // Create worksheet & export
  const ws = XLSX.utils.aoa_to_sheet(wsData);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Comparison Table');

  const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
  saveAs(new Blob([wbout], { type: 'application/octet-stream' }), 'comparison-table.xlsx');
        };


        useEffect(()=>{

            if(periodlabel.length == 1){
                setCOLUMN_WIDTH(300);
            }
            else if(periodlabel.length == 2){
                setCOLUMN_WIDTH(200);
            }
            else if(periodlabel.length > 2){
                setCOLUMN_WIDTH(100);
            }

        },[periodlabel.length])

          const periodCount = periodlabel.length;



          const exportToExcel = () => {
  const table = document.getElementById("export-table");

  if (!table) {
    alert("Table not found!");
    return;
  }

  const workbook = XLSX.utils.table_to_book(table, { sheet: "Sheet1" });
  const excelBuffer = XLSX.write(workbook, {
    bookType: "xlsx",
    type: "array",
  });

  const data = new Blob([excelBuffer], { type: "application/octet-stream" });
  saveAs(data, "table_export.xlsx");
};




  return (
    <div  style={loading == 'loading' ? {height: '90vh'} : null}>
      <div className='fs-3 fw-bold text-center mt-2 mb-3' style={{color: "#000078"}}>
        Financial Sheet Data
      </div>
      {
        loading == 'loaded' ?
      <div className='col-12 card shadow'>
        <div className='col-12 col-lg-6 col-md-6 m-2'>
            <Select
                    options={group}
                    placeholder="Select Group"
                    value={selectedGroup}
                    onChange={handleSelect}
                    isSearchable={true}
                    // isMulti
            />
        </div>
        <div className='col-12 col-lg-6 col-md-6 m-2'>
            <Select
                    options={mainsector}
                    placeholder="Select Cluster"
                    value={selectedMainSector}
                    onChange={handleSelect2}
                    styles={customSelectStyles}
                    isSearchable={true}
                    // isMulti
            />
        </div>
        <div className='col-12 col-lg-6 col-md-6 m-2'>
            <Select
                    options={sector}
                    placeholder="Select Sector"
                    value={selectedSector}
                    onChange={handleSelect3}
                    styles={customSelectStyles}
                    isSearchable={true}
                    // isMulti
            />
        </div>
        <div className='col-12 col-lg-6 col-md-6 m-2'>
            <Select
                    options={opinion}
                    placeholder="Select Opinion"
                    value={selectedOpinion}
                    onChange={handleSelect4}
                    styles={customSelectStyles}
                    isSearchable={true}
                    isMulti
            />
        </div>
        <div className='col-12 col-lg-6 col-md-6 m-2'>
            <Select
                    options={period}
                    placeholder="Select Period"
                    value={selectedPeriod}
                    styles={customStyles}
                    onChange={handleSelect5}
                    isSearchable={true}
                    isMulti
            />
        </div>
      </div> :
      (<div className="mt-5 mx-auto" style={{ width: "fit-content" }}>
              <div class="wrapper" id="loader2">
                <svg
                  class="hourglass"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 120 206"
                  preserveAspectRatio="none"
                >
                  <path
                    class="middle"
                    d="M120 0H0v206h120V0zM77.1 133.2C87.5 140.9 92 145 92 152.6V178H28v-25.4c0-7.6 4.5-11.7 14.9-19.4 6-4.5 13-9.6 17.1-17 4.1 7.4 11.1 12.6 17.1 17zM60 89.7c-4.1-7.3-11.1-12.5-17.1-17C32.5 65.1 28 61 28 53.4V28h64v25.4c0 7.6-4.5 11.7-14.9 19.4-6 4.4-13 9.6-17.1 16.9z"
                  />
                  <path
                    class="outer"
                    d="M93.7 95.3c10.5-7.7 26.3-19.4 26.3-41.9V0H0v53.4c0 22.5 15.8 34.2 26.3 41.9 3 2.2 7.9 5.8 9 7.7-1.1 1.9-6 5.5-9 7.7C15.8 118.4 0 130.1 0 152.6V206h120v-53.4c0-22.5-15.8-34.2-26.3-41.9-3-2.2-7.9-5.8-9-7.7 1.1-2 6-5.5 9-7.7zM70.6 103c0 18 35.4 21.8 35.4 49.6V192H14v-39.4c0-27.9 35.4-31.6 35.4-49.6S14 81.2 14 53.4V14h92v39.4C106 81.2 70.6 85 70.6 103z"
                  />
                </svg>
              </div>
            </div>)
      }

        {
            periodlabel.length > 0 &&
            <>
                <div className='mt-3'>
                    <button className='btn btn-primary' onClick={exportToExcel} style={{ marginBottom: '10px' }}>
                    Export Table to Excel
                    </button>
                 </div>

                <div className='card shadow col-12 mx-auto table-container' style={{ overflowX: 'auto', maxWidth: '100%', paddingBottom: '10px', maxHeight: '800px', overflowY: 'auto', overflowX: 'auto',  border: '1px solid #ccc'}}>
                  

                    {/* <table className='sticky-table' border="1" cellPadding="6" style={{
                        borderCollapse: 'collapse',
                        border: '2px solid black', width: '100%'
                    }}>
                    <thead>
                    <tr>
                        <th className="sticky-header top-0 z-20" style={{ border: '1px solid black' }}></th>
                        {comparisondata.map(op => (
                        <th className="sticky-header top-0 z-20"
                            key={op.name}
                            colSpan={periodlabel.length}
                            style={{
                            border: '1px solid black',
                            textAlign: 'center',
                            backgroundColor: '#e0e0e0',
                                minWidth: `${periodlabel.length * COLUMN_WIDTH}px`,
                                maxWidth: `${periodlabel.length * COLUMN_WIDTH}px`,
                                width: `${periodlabel.length * COLUMN_WIDTH}px`,
                            }}
                        >
                            {op.name}
                        </th>
                        ))}
                        <th className="sticky-header top-0 z-20" style={{ border: '1px solid black', backgroundColor: '#f0f0f0', minWidth:"200 !important",  minWidth: "100px", maxWidth: "100px", width: "100px", textAlign: 'center' }}>Total</th>
                    </tr>
                    <tr>
                        <th className="sticky-header top-row2 z-10" style={{ border: '1px solid black' }}></th>
                        {comparisondata.map(() =>
                        periodlabel.map(k => (
                            <th className="sticky-header top-row2 z-10" key={k} style={{ border: '1px solid black', backgroundColor: '#f9f9f9', textAlign: 'center', width: `${COLUMN_WIDTH}px`, minWidth: `${COLUMN_WIDTH}px` }}>{k}</th>
                        ))
                        )}
                        <th className="sticky-header top-row2 z-10" style={{ border: '1px solid black', backgroundColor: '#f9f9f9', minWidth: "100px", maxWidth: "100px", width: "100px", textAlign: 'center' }}>Average</th>
                    </tr>
                    </thead>
                    <tbody>
                    {sections.map(section => (
                        <React.Fragment key={section.name}>
                        <tr>
                            <td className='ms-1' colSpan={1 + comparisondata.length * periodlabel.length + 1} style={{ fontWeight: 'bold', border: '1px solid black', "color": "white", "backgroundColor": "#000078", minWidth: "400px", maxWidth: "400px", width: "400px" }}>
                            {" "}{section.name}
                            </td>
                        </tr>
                        {section.rows.map(rowId => (
                            <tr className='ms-1' key={rowId}>
                            <td style={{ border: '1px solid black', minWidth: "400px", maxWidth: "400px", width: "400px" }}>{rowId}</td>
                            {comparisondata.map(op => {
                                let currentSection = '';
                                let matchedRow = null;

                                for (const row of op.data) {
                                if (row.length === 1) {
                                    currentSection = row[0];
                                } else if (currentSection === section.name && row[0] === rowId) {
                                    matchedRow = row;
                                    break;
                                }
                                }

                                const values = matchedRow ? matchedRow.slice(1) : Array(periodlabel.length).fill(0);

                                return values.map((val, i) => (
                                <td
                                    key={`${op.name}-${rowId}-${i}`}
                                    style={{ border: '1px solid black', textAlign: 'center', width: `${COLUMN_WIDTH}px`, minWidth: `${COLUMN_WIDTH}px` }}
                                >
                                    {val}
                                </td>
                                ));
                            })}
                            <td style={{ border: '1px solid black', fontWeight: 'bold', textAlign: 'center', minWidth: "100px", maxWidth: "100px", width: "100px" }}>
                                {(() => {
                                const allValues = comparisondata.flatMap(op => {
                                    let currentSection = '';
                                    let matchedRow = null;

                                    for (const row of op.data) {
                                    if (row.length === 1) {
                                        currentSection = row[0];
                                    } else if (currentSection === section.name && row[0] === rowId) {
                                        matchedRow = row;
                                        break;
                                    }
                                    }

                                    return matchedRow ? matchedRow.slice(1) : Array(periodlabel.length).fill(0);
                                });

                                const numericValues = allValues
                                    .map(normalizeValue)
                                    .filter(v => typeof v === 'number' && !isNaN(v));

                                if (numericValues.length === 0) return '0.00';

                                const avg = numericValues.reduce((a, b) => a + b, 0) / numericValues.length;

                                return avg.toFixed(2);
                                })()}
                            </td>
                            </tr>
                        ))}
                        </React.Fragment>
                    ))}
                    </tbody>
                    </table> */}

                    <table className="sticky-table" id='export-table'>
                        <thead>
                        <tr>
                            <th className="sticky-header-top-0"></th>
                            {comparisondata.map((op) => (
                            <th
                                key={op.name}
                                colSpan={periodlabel.length}
                                className="sticky-header-top-0 text-align"
                                style={{
                                minWidth: `${periodlabel.length * 100}px`,
                                backgroundColor: '#e0e0e0',
                                 minWidth: `${periodlabel.length * COLUMN_WIDTH}px`,
                                maxWidth: `${periodlabel.length * COLUMN_WIDTH}px`,
                                width: `${periodlabel.length * COLUMN_WIDTH}px`,
                                }}
                            >
                                {op.name}
                            </th>
                            ))}
                            {periodlabel.map((label) => (
                            <th
                                key={`total-${label}`}
                                className="sticky-header-top-0 text-align"
                                rowSpan="2"
                                style={{ minWidth: '120px', backgroundColor: '#d0d0d0', textAlign:"center !important", }}
                            >
                                Total Sum <br /> {label}
                            </th>
                            ))}
                            {periodlabel.map((label) => (
                            <th
                                key={`avg-${label}`}
                                className="sticky-header-top-0 text-align"
                                rowSpan="2"
                                style={{ minWidth: '120px', backgroundColor: '#c0c0c0', textAlign:"center !important", }}
                            >
                                Average <br /> {label} 
                            </th>
                            ))}
                        </tr>
                        <tr>
                            <th className="sticky-header-top-1 text-align"  style={{width: `${COLUMN_WIDTH}px`, minWidth: `${COLUMN_WIDTH}px`, textAlign:"center !important",}}></th>
                            {comparisondata.map(() =>
                            periodlabel.map((k) => (
                                <th key={k} className="text-align sticky-header-top-1">
                                {k}
                                </th>
                            ))
                            )}
                        </tr>
                        </thead>

                    <tbody>
      {sections.map((section) => (
        <React.Fragment key={section.name}>
          <tr>
            <td
              colSpan={
                1 +
                comparisondata.length * periodlabel.length +
                periodlabel.length * 2
              }
              className="section-header"
            >
              {section.name}
            </td>
          </tr>

          {section.rows.map((rowId) => {
            const rowData = [];

            comparisondata.forEach((op, opIndex) => {
              const values = getCellValue(op, section.name, rowId);
              values.forEach((val, idx) => {
                const num = normalizeValue(val);
                rowData.push(val);
              });
            });

            return (
              <tr key={rowId}>
                <td style={{ fontWeight: 'bold', minWidth: '400px', textAlign: 'left !important' }}>
                  {rowId}
                </td>

                {rowData.map((val, idx) => (
                  <td className='text-align' style={{width: `${COLUMN_WIDTH}px`, minWidth: `${COLUMN_WIDTH}px`, textAlign:"center !important",}} key={idx}>{val}</td>
                ))}

                {periodlabel.map((_, idx) => {
                  const valuesForPeriod = comparisondata.map((op, opIdx) => {
                    const index = opIdx * periodlabel.length + idx;
                    const rawVal = rowData[index];
                    return normalizeValue(rawVal);
                  });
                  const total = valuesForPeriod.reduce((a, b) => a + b, 0);
                  return <td className='text-align' style={{textAlign:"center !important",}} key={`total-${idx}`}>{formatNumber(total)}</td>;
                })}

                {periodlabel.map((_, idx) => {
                  const valuesForPeriod = comparisondata.map((op, opIdx) => {
                    const index = opIdx * periodlabel.length + idx;
                    const rawVal = rowData[index];
                    return normalizeValue(rawVal);
                  });
                  const valid = valuesForPeriod.filter((v) => !isNaN(v));
                  const avg =
                    valid.length > 0
                      ? valid.reduce((a, b) => a + b, 0) / valid.length
                      : 0;
                  return <td className='text-align' style={{textAlign:"center !important",}} key={`avg-${idx}`}>{formatNumber(avg)}</td>;
                })}
              </tr>
            );
          })}
        </React.Fragment>
      ))}
    </tbody>
  </table>


                </div>
            </>
        }
      
    </div>
  )
}
